import './popup.less';
/**
 * @typedef {Object} PopupConfig
 * @property {string} targetElement
 * @property {string} closeElement
 * @property {function} onInit
 * @property {function} onDestroy
 */

/**
 * @param {PopupConfig} config
 */
export const PopupFactory = config => {
    const ESC_KEY_CODE = 27;
    if (config.targetElement === undefined) {
        throw new Error('Provide target element for popup initialize function');
    }

    const popupElement /* HTMLElement */ = document.querySelector(config.targetElement);

    function stopPropagationToFixMenu(event) {
        event.stopPropagation();
    }
    /**
     * Close popup on escape key
     */
    function closeOnEscape(event) {
        if (event.keyCode === ESC_KEY_CODE) {
            // eslint-disable-next-line
            hide();
        }
    }
    function hideScrollbar() {
        document.body.style.overflow = 'hidden';
    }

    /**
     * Prevent the page layout under popup to grow
     */
    function adjustPageUnderPopup(action) {
        const windowWidthBefore = document.body.offsetWidth;
        document.body.style.overflow = action === 'show' ? 'hidden' : '';
        const windowWidthAfter = document.body.offsetWidth;
        const trackWidth = windowWidthAfter - windowWidthBefore;
        const header = document.querySelector('.js-header-apc');
        document.body.style.paddingRight = action === 'show' ? `${trackWidth}px` : '';
        header.style.width = action === 'show' ? `${windowWidthBefore}px` : '';
    }

    /**
     * Close a complete your solution popup
     */
    function hide() {
        popupElement.style.display = 'none';
        popupElement.removeEventListener('click', stopPropagationToFixMenu);
        window.removeEventListener('keydown', closeOnEscape);
        adjustPageUnderPopup('hide');
        if (config.onDestroy !== undefined) {
            config.onDestroy();
        }
        Array.from(document.querySelectorAll(config.closeElement)).forEach(nodeElement =>
            nodeElement.removeEventListener('click', hide)
        );
        window.removeEventListener('resize', hideScrollbar);
    }
    /**
     * Show a complete your solution popup
     */
    function show() {
        popupElement.style.display = '';
        popupElement.addEventListener('click', stopPropagationToFixMenu);
        adjustPageUnderPopup('show');
        window.addEventListener('keydown', closeOnEscape);
        if (config.onInit !== undefined) {
            config.onInit();
        }
        Array.from(document.querySelectorAll(config.closeElement)).forEach(nodeElement =>
            nodeElement.addEventListener('click', hide)
        );
        window.addEventListener('resize', hideScrollbar);
    }

    function isExist() {
        return Boolean(popupElement);
    }

    return {
        hide,
        show,
        isExist,
    };
};
